import React from 'react';
import { bool, string, shape } from 'prop-types';
import Product from 'components/Product';
import styles from './styles';

function ProductTeaser(props) {
  const { descriptionHtml, isAffiliate, isAmp, product, titleHtml } = props;

  if (!product) {
    return null;
  }

  return (
    <div className="ProductTeaser">
      <Product isAffiliate={isAffiliate} isAmp={isAmp} {...product} />

      {titleHtml && (
        <div
          className="ProductTeaser__heading"
          dangerouslySetInnerHTML={{ __html: titleHtml }}
        />
      )}

      {descriptionHtml && (
        <div
          className="ProductTeaser__description"
          dangerouslySetInnerHTML={{ __html: descriptionHtml }}
        />
      )}

      <style jsx>{styles}</style>
    </div>
  );
}

ProductTeaser.propTypes = {
  descriptionHtml: string,
  isAffiliate: bool.isRequired,
  isAmp: bool.isRequired,
  product: shape(),
  titleHtml: string
};

ProductTeaser.defaultProps = {
  descriptionHtml: undefined,
  product: undefined,
  titleHtml: undefined
};

export default ProductTeaser;
